import * as React from 'react';
import { getAuthProviderFromReferrer } from '../../../utilities';

interface BackgroundAuthProps {
    dispatchFetchBackgroundAuthUri: (provider: string) => void;
    dispatchGetInfoForClientTokenRetrieval: () => void;
    backgroundAuthUri: string;
    isUWP: boolean;
    isAgave: boolean;
}

export class BackgroundAuth extends React.Component<BackgroundAuthProps> {
    public constructor(props: BackgroundAuthProps) {
        super(props);
    }
    public componentDidMount() {
        if (this.props.isUWP && !this.props.isAgave) {
            this.props.dispatchGetInfoForClientTokenRetrieval();
        } else {
            this.props.dispatchFetchBackgroundAuthUri(getAuthProviderFromReferrer().toString());
        }
    }
    public render() {
        if (this.props.isAgave && this.props.backgroundAuthUri != null) {
            return (
                <iframe id="backgroundAuthContactUs"
                        sandbox="allow-forms allow-scripts allow-popups allow-top-navigation"
                        role="presentation"
                        src={this.props.backgroundAuthUri}
                        height="1"
                        width="1" />
            );
        }
        return (<div />);
    }
}
